import { Outlet } from "react-router-dom";
import AdminHeader from "./AdminHeader";

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-[var(--color-bg-primary)]">
      {/* Clean ambient glow — no heavy WebGL */}
      <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-64 left-1/3 h-[700px] w-[700px] -translate-x-1/2 rounded-full bg-[var(--color-accent)]/[0.03] blur-[160px]" />
        <div className="absolute bottom-0 right-0 h-[400px] w-[500px] rounded-full bg-blue-900/10 blur-[120px]" />
      </div>
      <AdminHeader />
      <main className="relative">
        <div className="mx-auto max-w-6xl p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
